seedWebApp.controller('DicColsController', ['$scope', 'DicService', 'ToastService',
    function ($scope, DicService, ToastService) {

        $scope.prefs = {
            name: 'DicColsGrid',
            sortByCol: null,
            canAdd: false,
            canEdit: true,
            canDelete: false
        };

        $scope.countService = DicService.getColsCount;
        $scope.loadService = DicService.getCols;
        $scope.loadColumns = DicService.getColColumns;
        $scope.resetService = DicService.resetCache;

        $scope.qtStockClass = function (item) {
            return 'qt-stocks';
        };

        $scope.qtPOClass = function (item) {
            return 'qt-pos';
        };


        $scope.columns = [
            { name: 'DicID', display: 'Tabela', customClass: function () { return 'agp-color'; }, filterOptions: [], width: 10, isKey: true },
            //{ name: 'DicName', display: 'Nome', filterOptions: [], limitTo: '35', width: 15 },
            { name: 'ColName', display: 'Campo', filterOptions: [], limitTo: '35', width: 15  },
            { name: 'ColType', display: 'Tipo', filterOptions: [], limitTo: '35', width: 15 },
            //{ name: 'ExtTableName', display: 'Integrações', filterOptions: [], width: 5, customClass: $scope.qtPOClass },
            //{ name: 'ParentTable', display: 'Parent', filterOptions: [], width: 5 },
            //{ name: 'QtDics', display: '# Campos', filterOptions: [], width: 5 },
        ];

        //$scope.insertNew = function () {
        //    DicService.openDicModal();
        //}

        //$scope.prefs.customEdit = function (item) {
        //    DicService.openDicModal(item.DicID);
        //};

        $scope.getTotal = function () {
            $scope.loadingTotal = true;
            $scope.countService().then(function (response) {
                $scope.loadingTotal = false;
                $scope.totalItems = response.data;
            });
        };

        $scope.getTotal();

        $scope.searchMode = function () {
            $scope.$broadcast('inputSearch', $scope.filterString);
        };

        $scope.doRefresh = function () {
            $scope.$broadcast('refreshServiceGrid');
        };

        $scope.toExcel = function () {
            $scope.$broadcast('toExcel', 'dicCols');
        };

       

    }]);
